import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClearFilters = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.88098 7.04749H13.1557C13.2275 7.77056 13.4533 8.44832 13.7999 9.04749H2.88098V7.04749ZM9.88098 19.0475H13.881V17.0475H9.88098V19.0475ZM5.88098 14.0475H17.881V12.0475H5.88098V14.0475Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.1302 2.79761C17.0934 2.79761 16.1548 3.21319 15.4756 3.89252C14.7964 4.57185 14.3809 5.51058 14.3809 6.54761C14.3809 8.62166 16.058 10.2976 18.1317 10.2976C20.2053 10.2976 21.8809 8.62241 21.8809 6.54761C21.8802 4.47581 20.2038 2.79836 18.1302 2.79761ZM17.0736 4.4209L18.1361 5.48352L19.1985 4.4209L20.2609 5.48352L19.1985 6.54614L20.2609 7.60876L19.1985 8.67138L18.1361 7.60876L17.0736 8.67138L16.0112 7.60876L17.0736 6.54614L16.0112 5.48352L17.0736 4.4209Z",
		fill: "currentColor"
	})]
});
export default SvgClearFilters;
